import React from 'react';
import { ProgressBar } from 'react-bootstrap';

import useGlobal from '../../../../../store';
import { FormControl } from '../../../../../facturotopia';
import { TheError } from '../../../../../shared/responses/TheResult';

const mapState = (store) => {
  return store.modulo.catalogo.cliente.upload;
};

const mapActions = (actions) => {
  return { ...actions.modulo.catalogo.cliente.upload };
};

const CatalogoClienteUploadForm = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { data, progress, busy, error } = state;

  const select = (event) => {
    actions.onChange({
      file: event.target.files[0],
    });
  };

  const handleOnChange = (values) => {
    actions.onChange(values);
  };

  return (
    <>
      {!!error && <TheError error={error} />}

      <FormControl
        type="select"
        label="Tipo de archivo"
        name="catalogo"
        placeholder=""
        help=""
        value={data.catalogo}
        options={options}
        onChange={handleOnChange}
      />

      <label>
        <input
          type="file"
          accept=".csv, .txt, .xls, .xlsx"
          onChange={select}
        />
      </label>

      <div className="p-3">
        <label>Instrucciones.</label>
        <ul className="list-unstyled">
          <li>1. Descarga el template</li>
          <li>2. Sigue la guía de llenado</li>
          <li>3. Sube el archivo</li>
        </ul>
      </div>

      {(busy || progress > 0) && !!data.file && (
        <ProgressBar
          striped
          variant="info"
          label={`${progress}%`}
          now={progress}
        />
      )}
    </>
  );
};

export default CatalogoClienteUploadForm;

const options = [
  {
    label: 'Carta Porte',
    value: 'carta-porte',
  },
  {
    label: 'Carta Porte Autocompletado',
    value: 'carta-porte-autocompletado',
  },
];
